<button
  class="tile"
  type="button"
  [disabled]="tile.disabled"
  [class.selected]="selected"
  [class.disabled]="tile.disabled"
  (click)="onClick()">
  <div class="tile-container tw-flex tw-justify-center tw-items-center tw-gap-2 tw-p-3">
    <div class="tile-radio tw-flex tw-shrink-0"></div>
    <div
      *ngIf="tile.icon"
      class="tile-icon">
      <mg-icon
        [style.color]="tile.color"
        [icon-namespace]="tile?.iconNamespace">
        {{ tile.icon }}
      </mg-icon>
    </div>
    <ng-template #assetPath>
      <mg-image
        class="tile-asset"
        [srcs]="[tile.assetPath]">
      </mg-image>
    </ng-template>
    <div class="tw-flex tw-grow">
      <mg-text
        variant="body-sm-secondary"
        textAlign="left"
        [color]="tile.disabled ? 'on-disabled-bg' : 'surface'"
        [numberOfLines]="2">
        {{ tile.name }}
      </mg-text>
    </div>

    <mg-tooltip
      class="tooltip"
      *ngIf="tile.tooltip"
      [label]="tile.tooltip">
    </mg-tooltip>
  </div>
</button>
